import DropdownValueWithRatingStars from '@/storybook/components/FormCollection/components/DropdownValueWithRatingStars/DropdownValueWithRatingStars';
import { createStableObjectHash } from '@/storybook/components/FormCollection/utils/utils';
import { SelectItem } from '@/types/ui';
import { useMemo, useRef } from 'react';

type UseMultiLevelSelectButtonValueProps<T> = {
  value: SelectItem<T>[];
  optionsMap: Map<string, SelectItem<T>>;
};

export const useMultiLevelSelectButtonValue = <T,>({ value, optionsMap }: UseMultiLevelSelectButtonValueProps<T>) => {
  const valueListContainerRef = useRef<HTMLDivElement>(null);

  const dropdownButtonValue = useMemo(() => {
    if (value.length === 0) return '';

    const buttonValue: SelectItem<string>[] = value.map(currentValue => {
      const currentValueKey =
        typeof currentValue.value === 'object' && currentValue.value !== null
          ? createStableObjectHash(currentValue.value)
          : String(currentValue.value);

      const foundOption = optionsMap.get(currentValueKey);

      if (!foundOption) {
        return {
          ...currentValue,
          label: String(currentValue.value),
          value: currentValueKey,
        };
      }

      return {
        ...foundOption,
        level: currentValue.level,
        value: currentValueKey,
      };
    });

    return <DropdownValueWithRatingStars value={buttonValue} ref={valueListContainerRef} />;
  }, [value, optionsMap]);

  return dropdownButtonValue;
};
